const SidebarHeader = () => {
    return(
        <div className="sidebar-header">
            <div className="logo-circle">
                <img src='/favicon.png' alt='Logo Smart Olfativos'/>
            </div>
            <div className="sidebar-title-text">
                <div className="sidebar-title-1">Painel Licenciado</div>
                <div className="sidebar-title-2">Smart Olfativos</div>
            </div>
        </div>
    )
}

export default SidebarHeader;